import { settingsActions, useTheme } from '@/stores/settingsStore';
import { isMITX } from '@/utils/stackUtils';

const sesameThemes = {
  'sesame-xsmall': 'Extra Small',
  'sesame-small': 'Small (default)',
  'sesame-medium': 'Medium',
  'sesame-large': 'Large',
  'sesame-xlarge': 'Extra Large',
};

const moocThemes = {
  'mooc-xsmall': 'Extra Small',
  'mooc-small': 'Small',
  'mooc-medium': 'Medium',
  'mooc-large': 'Large',
  'mooc-xlarge': 'Extra Large',
};

const TextSizePicker = () => {
  const currentTheme = useTheme();
  const changeTheme = event => {
    const theme = event.target.value;
    settingsActions.updateTheme(theme);
  };

  const themes = isMITX() ? moocThemes : sesameThemes;

  return (
    <div className="w-64">
      <label className="text-sm">Text Size</label>
      <select
        name="theme"
        defaultValue={currentTheme}
        className="select select-bordered w-full select-sm max-w-xs"
        onChange={changeTheme}
      >
        {Object.entries(themes).map(([key, value]) => (
          <option key={key} value={key}>
            {value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TextSizePicker;
